/* eslint-disable react/prop-types */
import React from 'react';
import { KatButton, KatModal } from '@amzn/katal-react';
import { useTranslation } from 'src/utils';
import {
  deletePost, selectDeleteDraftStatus, threadDetailActions, selectDeletePostStatus,
} from 'src/redux/slices/threadDetailSlice';
import { useAppDispatch, useAppSelector } from 'src/redux/hooks';
import { createPortal } from 'react-dom';
import FetchStatus from 'src/types/FetchStatus';

export enum ConfirmationType {
  delete = 'delete',
  cancelReply = 'cancelReply',
}
interface ConfirmationModalProps {
  postId: string | undefined;
  threadId: string;
  type: ConfirmationType;
  onClose: () => void;

}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  postId, threadId, type, onClose,
}) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const deleteDraftStatus = useAppSelector(selectDeleteDraftStatus);
  const deletePostStatus = useAppSelector(selectDeletePostStatus);
  const isDeleting = deleteDraftStatus === FetchStatus.loading
    || deletePostStatus === FetchStatus.loading;

  const getModalInformation = () => {
    if (type === ConfirmationType.delete && postId) {
      return {
        title: t('confirmation_deletePost_title'),
        content: t('confirmation_deletePost_content'),
        submitActionLabel: t('confirmation_deletePost_actionLabel'),
        onSubmit: () => {
          dispatch(deletePost({ threadId, postId })).then(onClose);
        },
      };
    }
    return {
      title: t('confirmation_cancelReply_title'),
      content: t('confirmation_cancelReply_content'),
      submitActionLabel: t('confirmation_cancelReply_actionLabel'),
      onSubmit: () => {
        /**
         * PostId is present only for drafts, we dont pass postId if its an edit
         */
        if (postId) {
          dispatch(deletePost({ threadId, postId })).then(onClose);
        } else {
          dispatch(threadDetailActions.setDraftPost(undefined));
          dispatch(threadDetailActions.setDraftContent({}));
          onClose();
        }
      },
    };
  };

  const modalInformation = getModalInformation();

  return createPortal(
    <KatModal
      visible
      onClose={onClose}
      persistent
    >
      <span slot="title">{modalInformation.title}</span>
      <p>
        {modalInformation.content}
      </p>
      <div slot="footer" className="kat-group-horizontal">
        <KatButton
          onClick={onClose}
          variant="secondary"
          label={t('confirmation_close')}
          disabled={isDeleting}
        />
        <KatButton
          onClick={modalInformation.onSubmit}
          label={modalInformation.submitActionLabel}
          disabled={isDeleting}
          loading={isDeleting}
        />
      </div>
    </KatModal>,
    document.querySelector('#seller-forums') as Element,
  );
};
export default ConfirmationModal;
